<template>
  <div class="box">
    <el-upload :limit="limit"  :headers="uploadHeader" :data="extraParams" :action="uploadUrl" :class="{ 'hide': hideUpload }"
               list-type="picture-card" :with-credentials="true" :on-preview="handlePictureCardPreview" :on-success="handleSuccess" :file-list="fileList" :before-upload="beforeUpload"
               :on-remove="handleRemove">
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>


<script>
  export default {
    props: {
      value: {
        type: Array,
        require: true
      },
      type: {
        type: String,
        required: true
      },
      id: {
        type: String,
        default: null
      },
      limit: {
        type: Number,
        default: 5
      }
    },
    data() {
      return {
        dialogImageUrl: '',
        dialogVisible: false,
        count: 0,
        pictures: [],
        fileList: [],
        deleteUrl: SZH.assets.api + '/File/DeleteImage',
        hideUpload: false,
        photos: [],
      };
    },
    computed: {
      uploadUrl() {
        // return SZH.assets.api + '/File/PostImage/' + this.type + (this.id == null ? '' : '/' + this.id)
        return SZH.assets.api + '/File/PostFile'
      },
      uploadHeader() {
        var token = localStorage.ms_token;
        return {
          Authorization: 'Bearer ' + token
        }
      },
      extraParams(){
        return {
          upLoadType:'1',
          upLoadFolder:'',
          ImageType:this.type,
          code:''
        }
      }
    },
    methods: {
      handleRemove(file, fileList) {
        var self = this;
        self.count = fileList.length;
        self.change();
        self.photos = [];
        self.$emit("input", this.photos);
      },
      handleSuccess(response, file, fileList) {
        if (response && response[0].success == true) {
          this.count = fileList.length;
          this.change();
          this.photos = this.value || [];
          this.photos.push({
            // Id: response.Data.Id,
            Url: response[0].FileName
          });
          this.$emit("input", this.photos);
        }else{
          this.$message.error(response.message)
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      beforeUpload(file){
        const _self = this;
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'|| file.type === 'image/gif';
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isJPG) {
          _self.$message.error('上传的图片只能是 JPG 或 PNG 格式!');
        }
        else if (!isLt2M) {
          _self.$message.error('上传的图片大小不能超过 10MB!');
        }
        return isJPG && isLt2M;
      },
      change() {
        if(this.count >= this.limit)
          this.hideUpload = true;
        else
          this.hideUpload = false;
      }
    },
    watch:{
      value: {
        handler(val) {
          this.fileList = [];
          this.count = val.length;
          this.change();
          for(var i in val) {
            if(typeof(val[i]) !== "function")
            {
              this.fileList.push({
                url:  SZH.assets.image+'/' + val[i].Url
              });
            }
          }
        },
        deep: true
      }
    },
    mounted() {
      this.fileList = [];
      this.count = this.value.length;
      this.change();
      for(var i in this.value) {
        if(typeof(this.value[i]) !== "function")
        {
          this.fileList.push({
            url:  SZH.assets.image +'/' + this.value[i].Url
          });
        }
      }

    }
  }
</script>

<style scoped>
  .box {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PictureList/PictureListSing.vue